import React, { Component } from 'react';
import styles from './styles.scss';
import { linkifyText } from '../Building/Main/helper';
import { gaEvent, trackGA } from 'services/ga';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import debounce from 'lodash.debounce';

const handleTrackEvent = ({ eventName, screenName, eventContent, user_id }) => {
  trackGA(
    gaEvent[eventName]({
      screenName,
      eventContent,
      user_id,
    })
  );
};

class WarningRow extends Component {
  componentDidMount() {
    const { children, profile } = this.props;

    const debouncedTrackEvent = debounce(() => {
      handleTrackEvent({
        eventName: 'infoBannerShow',
        screenName: location.pathname,
        eventContent: children,
        user_id: profile.id,
      });
    }, 2000);

    debouncedTrackEvent();
  }

  render() {
    const { children, color, backgroundColor, profile } = this.props;

    return (
      <div
        className={styles.WarningRow}
        style={{ color, backgroundColor }}
        onClick={() =>
          handleTrackEvent({
            eventName: 'infoBannerClick',
            screenName: location.pathname,
            eventContent: children,
            user_id: profile.id,
          })
        }
      >
        {linkifyText(children)}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default withRouter(withTranslation()(connect(mapStateToProps, null)(WarningRow)));



// WEBPACK FOOTER //
// ./src/components/WarningRow/WarningRow.js